@if (type() === button.FILLED) {
  <button
    mat-stroked-button
    type="button"
    class="!rounded-lg !transition-all !w-full !h-9 !font-bold !text-white hover:!bg-primary-75 !bg-primary disabled:!opacity-70 disabled:!pointer-events-none disabled:!grayscale !text-sm"
    [class]="styleClass()"
    [disabled]="isDisabled()"
    (click)="handleClick()">

    <span class="flex items-center justify-center gap-2">

      @if (icon() && iconPosition() === 'start') {
        <mat-icon>{{ icon() }}</mat-icon>
      }

      <span>{{ label() }}</span>

      @if (icon() && iconPosition() === 'end') {
        <mat-icon>{{ icon() }}</mat-icon>
      }

    </span>

  </button>
}

@if (type() === button.OUTLINED) {
  <button
    mat-stroked-button
    type="button"
    class="!rounded-lg !transition-all !w-full !h-9 !font-bold !bg-white !border !border-primary hover:!bg-primary-75 hover:!text-white disabled:!opacity-70 disabled:!pointer-events-none disabled:!grayscale !text-sm"
    [class]="styleClass()"
    [disabled]="isDisabled()"
    (click)="handleClick()">

    <span class="flex items-center justify-center gap-2">

      @if (icon() && iconPosition() === 'start') {
        <mat-icon>{{ icon() }}</mat-icon>
      }

      <span>{{ label() }}</span>

      @if (icon() && iconPosition() === 'end') {
        <mat-icon>{{ icon() }}</mat-icon>
      }

    </span>

  </button>
}

@if (type() === button.ACCENT) {
  <button
    mat-stroked-button
    type="button"
    class="!rounded-lg !w-full !transition-all !my-1 !h-9 !font-bold !bg-accent !border !border-accent hover:!border-primary disabled:!opacity-60 disabled:!pointer-events-none disabled:!grayscale !text-sm"
    [class]="styleClass()"
    [disabled]="isDisabled()"
    (click)="handleClick()">

    <span class="flex items-center justify-center gap-2">

      @if (icon() && iconPosition() === 'start') {
        <mat-icon>{{ icon() }}</mat-icon>
      }

      <span>{{ label() }}</span>

      @if (icon() && iconPosition() === 'end') {
        <mat-icon>{{ icon() }}</mat-icon>
      }

    </span>

  </button>
}